var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"d-flex flex-column",attrs:{"cols":"12","md":"8"}},[_c('QuestionCard')],1),_c('v-col',{staticClass:"d-flex flex-column",attrs:{"cols":"12","md":"4"}},[_c('AnswerCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }